import { PaymentErrorCategory } from "@app/enums/new-ticket-disposition";

export interface NewTicket {
  request_type: string;
  disposition: string;
  subdisposition: string;
  additional_information: string;
  attachments: Attachment[];
  HasAssociatedReconciliation__c?: string;
  ReconciliationNumber__c?: string;
  PaymentErrorType__c?: PaymentErrorCategory[];
}

export interface Attachment {
  url: string;
}
